// useFetchAppVersion.js
import { useState, useEffect } from "react";

const useFetchAppVersion = () => {
  const [appVersion, setAppVersion] = useState("Loading...");

  useEffect(() => {
    const fetchAppVersion = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_API}api/version/`,
        );
        const data = await response.json();
        setAppVersion(data.version);
      } catch (error) {
        console.error("Error fetching app version:", error);
        setAppVersion("Unavailable");
      }
    };

    fetchAppVersion();
  }, []);

  return appVersion;
};

export default useFetchAppVersion;
